<template>
  <div>
    <z-stance v-show="showStance" :btn-text="btnText" :show-info="false" :descText="stanceInfo" @click="checkStatus"/>
  </div>
</template>

<script>
import { Stance } from '@zz-common/zz-ui'
import { checkAuditStatus } from '../../api/resourceApi'
import { queryParams } from '../../lib/utils'

const query = queryParams()
export default {
  name: 'ProductQua',
  data() {
    return {
      infoId: query.infoId || this.$route.query.infoId,
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      reasonId: query.reasonId || this.$route.query.reasonId,
      showStance: false,
      btnText: '点击重试',
      stanceInfo: '网络错误'
    }
  },
  components: {
    zStance: Stance
  },
  methods: {
    checkStatus() {
      checkAuditStatus({ sourceCode: this.sourceCode, infoId: this.infoId })
        .then((res) => {
          console.log('checkStatus', res)
          const { auditStatus, statusDesc = '' } = res
          if (auditStatus == 0) { // 审核库无数据--跳转至信息提交页面
            this.$router.replace({
              path: '/productqua/submit',
              query: {
                sourceCode: this.sourceCode,
                infoId: this.infoId,
                reasonId: this.reasonId
              }
            })
          } else { // 审核库有数据--跳转至审核状态提示页
            this.$router.replace({
              path: '/productqua/status',
              query: {
                auditStatus,
                statusDesc,
                sourceCode: this.sourceCode,
                infoId: this.infoId,
                reasonId: this.reasonId
              }
            })
          }
        })
        .catch((e) => {
          console.log('errMsg', e)
          this.showStance = true
          this.stanceInfo = e
        })
    }
  },
  created() {
    this.checkStatus()
  }
}

</script>
<style>
</style>